import { createService } from 'reservice'
import * as types from '../actionTypes'

export const fetchWssid = createService(types.FETCH_WSSID)
export const fetchSeWssid = createService(types.FETCH_SE_WSSID)
export const fetchUser = createService(types.FETCH_USER)
export const fetchSeUser = createService(types.FETCH_SE_USER)
export const fetchPrivilegedPages = createService(types.FETCH_PRIVILEGE_PAGES)
export const fetchFeatureConfig = createService(types.FETCH_FEATURE_CONFIG)
export const fetchSingleFeatureConfig = createService(types.FETCH_SINGLE_FEATURE_CONFIG)
export const checkPrivilege = createService(types.CHECK_PRIVILEGE)
export const createLog = createService(types.CREATE_LOG)
export const fetchBase64Yimg = createService(types.FETCH_BASE64_YIMG)

export const fetchAnnouncements = createService(types.FETCH_ANNOUNCEMENTS)
export const updateAnnouncement = createService(types.UPDATE_ANNOUNCEMENT)
export const fetchActivities = createService(types.FETCH_ACTIVITIES)
export const fetchUnhandledActivitiesCount = createService(types.FETCH_UNHANDLED_ACTIVITIES_COUNT)

// S3 reservice
export const fetchTempCredential = createService(types.FETCH_TEMP_CREDENTIAL)
export const fetchS3Object = createService(types.FETCH_S3_OBJECT)
export const fetchS3Wssid = createService(types.FETCH_S3_WSSID)
